var IconType = /* @__PURE__ */ ((IconType2) => {
  IconType2["Compute"] = "compute";
  IconType2["Data"] = "data";
  IconType2["Database"] = "database";
  IconType2["Storage"] = "storage";
  IconType2["Search"] = "search";
  IconType2["ML"] = "ml";
  return IconType2;
})(IconType || {});

export { IconType };
//# sourceMappingURL=Icon.esm.js.map
